import { useUserContext } from '@/auth/UserContext';
import { useProfileRestriction } from '@/components/ProfileRestriction/useProfileRestriction';
import { SubscriptionState, type SubscriptionBannerState } from '@/types/user';
import { calculateDaysRemaining } from '@/utils/date';

const EXPIRES_SOON_THRESHOLD_DAYS = 10;

export const useExpirationBanner = (): SubscriptionBannerState | null => {
  const { user } = useUserContext();
  const { isRestricted } = useProfileRestriction();
  const subscription = user?.premiumSubscription;

  if (isRestricted) {
    return null;
  }

  if (subscription?.isActive === false) {
    return { kind: SubscriptionState.Inactive };
  }

  if (subscription?.isActive === true && subscription.endDate) {
    const daysRemaining = calculateDaysRemaining(subscription.endDate);

    if (daysRemaining >= 0 && daysRemaining <= EXPIRES_SOON_THRESHOLD_DAYS) {
      return { kind: SubscriptionState.ExpiringSoon, daysRemaining };
    }
  }

  return null;
};
